import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=0204ecaa&scoped=true"
import script from "./Affiliate.vue?vue&type=script&lang=js"
export * from "./Affiliate.vue?vue&type=script&lang=js"
import style0 from "./Affiliate.vue?vue&type=style&index=0&id=0204ecaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204ecaa",
  null
  
)

export default component.exports